import { styled } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import Button from "../../../../customs/Button";
import { NotificationContext } from "../../../../providers/notification";
import apiCall from "../../../../utils/apiCall";

interface ComponentProps {
    ScoreId: number;
    description: string;
    Score:number;
    handleClose: () => void;
}
const DeleteScoreContent: React.FC<ComponentProps> = ({ ScoreId, description, handleClose, Score}) => {
    const queryClient = useQueryClient();
    const { showNotification } = useContext(NotificationContext);

    const deleteScore = (id: number) => {
        return apiCall().get(`/SetUp/DeleteScoreById?scoreId=${id}`);
    };

    const deleteScoreMutation = useMutation(['delete-score'], deleteScore, {retry: 0});

    const deleteQualificationHandler = async (id : number) => {
        try { 
            await deleteScoreMutation.mutateAsync(id, {
                onSuccess: () => {
                    showNotification({
                        message: 'Score deleted successfully',
                        type: 'success'
                    })
                    queryClient.refetchQueries(['get-AllScore']);
                    handleClose();
                }
            })
        } catch (error: any) {
            showNotification({
                message: error?.response?.data?.title || error?.message,
                type: 'error',
            })
        }
    };

    const handleDeleteQualification = (id : number) => deleteQualificationHandler(id);

    return (
        <StyledContainer>
            <StyledText>You are about to delete score</StyledText>
            <ButtonWrapper>
                <ButtonContainer>
                    <StyledButton text='Cancel' onClick={handleClose}/>
                    <StyledButton 
                        onClick={() => handleDeleteQualification(ScoreId)} 
                        type="submit" 
                        text={deleteScoreMutation.isLoading ? 'Deleting...' : 'Yes, Delete'}
                        disabled={deleteScoreMutation.isLoading}
                    />
                </ButtonContainer>
            </ButtonWrapper>
        </StyledContainer>
    )
}

export default DeleteScoreContent;

const StyledContainer = styled('div')`
    margin-inline-start: 3.5rem;
    margin-block: 2.5rem;
`

const ButtonWrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    margin-block: 2.5rem;
    padding-inline: 3.5rem;
`

const ButtonContainer = styled('div')`
    display: flex;
    gap: 2rem;
`

const StyledButton = styled(Button)`
    padding-block: 1rem;
    padding-inline: 2rem;
    background-color: #DD5151;
`

const StyledText = styled('span')`
    color: #232323;
    font-size: 1.4rem;
    font-weight: 400;
`